import {PartialFrameElements} from '../type/PartialFrameElements.interface';
import {TextViewerCoreOption} from '../type/TextViewerCoreOption.type';
import {applyContentElementVisibility} from './applyContentElementVisibility';
import {applyContentInlineStyles} from './applyContentInlineStyles';
import {applySettingStylesForPageMode} from './applySettingStylesForPageMode';
import {applySettingStylesForScrollMode} from './applySettingStylesForScrollMode';
import {reviseImagesInContentElement} from './reviseImagesInContentElement.function';

/**
 * 기본 스타일, 뷰어 설정 스타일, 컨텐츠 스타일을 모두 적용하는 함수
 */
export async function applyStyles(param: {
  onClickImage?: (element: HTMLImageElement | SVGSVGElement) => void;
  frameElements: PartialFrameElements;
  option: TextViewerCoreOption;
  isPageTextViewer: boolean;
}) {
  applyContentElementVisibility({
    frameElements: param.frameElements,
    visible: false,
  });
  if (param.isPageTextViewer) {
    applySettingStylesForPageMode(param);
  } else {
    applySettingStylesForScrollMode(param);
  }
  await reviseImagesInContentElement(param);
  applyContentInlineStyles(param);
  applyContentElementVisibility({
    frameElements: param.frameElements,
    visible: true,
  });
}
